import { IFilter } from '@epicuro-next/ataraxia/models';
import {
  FiltersFieldIds,
  standaloneFilters,
} from '@epicuro-next/models/order-book';
import { OrderFilter } from 'graphql-api/baskets-api-interfaces';

export const isRegularFilter = (filter: OrderFilter | IFilter) =>
  !standaloneFilters.includes(filter.fieldId as FiltersFieldIds);
